import InfoBoxDetailed from './InfoBoxDetailed';

export default InfoBoxDetailed;
